import { singleton } from 'tsyringe';
import { BaseHttpClientApi } from '@/modules/http-client/domain/client/BaseHttpClientApi';

@singleton()
export class AnonymousHttpClientApi extends BaseHttpClientApi {}
